var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 13.8H10.4367C8.90773 13.8 8.14327 13.8 7.85403 13.303C7.56479 12.806 7.94244 12.1413 8.69774 10.812L11.0653 6.64512C11.4403 5.98516 11.6277 5.65517 11.8139 5.70436C12 5.75354 12 6.13307 12 6.89213V9.7C12 9.9357 12 10.0536 12.0732 10.1268C12.1464 10.2 12.2643 10.2 12.5 10.2H13.5633C15.0923 10.2 15.8567 10.2 16.146 10.697C16.4352 11.194 16.0576 11.8587 15.3023 13.188L12.9347 17.3549C12.5597 18.0148 12.3723 18.3448 12.1861 18.2956C12 18.2465 12 17.8669 12 17.1079V14.3C12 14.0643 12 13.9464 11.9268 13.8732C11.8536 13.8 11.7357 13.8 11.5 13.8Z",
    stroke: "#33363F"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9,
    stroke: "#33363F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightning);
export default __webpack_public_path__ + "static/media/lightning.323c03b2eedfa7eeff6c33bd53bf361f.svg";
export { ForwardRef as ReactComponent };